  <template>
  <div class="order">
    <div class="order-header">
      <div class="order-no notMobile">
        订单号：<a style="text-decoration: underline;line-height:20px;" target="_blank" :href="order.url">{{order.business_order_no}}</a>
        <p>
          <el-popover v-if="order.remark"
            placement="bottom"
            trigger="hover">
            <p>{{order.iconTitle}}</p>
            <a slot="reference"><i class="iconfont joyorderIcon" :class="{'el-icon-joyorder26 taobao':order.remark.indexOf('淘宝下单')==0,'el-icon-joyorderweixin':order.remark.indexOf('微信下单')==0}"/></a>
          </el-popover>
          <a>{{formatStatus(order.status)}}</a>
          <!--<el-popover
            placement="bottom"
            width="260"
            trigger="hover">
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;float:left;margin-right:5px;">
                任务来源:
              </span>
              <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
                {{order.source === "0"? 'PC端':'小程序'}}
              </span>
            </p>
            <p v-if="isSingle" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;float:left;margin-right:5px;">
                模式:
              </span>
              <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
                {{order.service_type == 1? '下单':'下单+转运'}}{{order.type == 2 ? '/ 帮我找货':''}}
              </span>
            </p>
            <p v-if="isSingle && order.buyer.email" class="clearfix" style="margin-top: 5px;">
              <span style="display:inline-block;float:left;margin-right:5px;">
                联系邮箱:
              </span>
              <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
                {{order.buyer.email}}
              </span>
            </p>
            <p style="margin-top: 5px;">
              {{order.conditions.check_full_goods ? '部分商品缺货时仍可下单' : '部分商品缺货时不能下单'}}
            </p>

            <p v-if="order.realRemark" class="clearfix" style="margin-top: 5px;word-break: break-word;">
              <span style="display:inline-block;float:left;">备注：</span>
              <span style="display:inline-block;width:140px;float:left;">{{order.realRemark}}</span>
            </p>
            <p  class="clearfix" style="margin-top: 5px;">
              <span v-if="order.support_transport_service == '1'">无需下单人提供转运服务</span>
              <span v-if="order.support_transport_service == '2'">需下单人提供转运服务</span>
            </p>

            <a slot="reference">下单说明<i class="el-icon-caret-bottom"></i></a>
          </el-popover>-->
          <span v-if="order.conditions.single_id > 0 && !isSingle">
            {{order.conditions.single_name}}
          </span>
          <span class="search_tag" @click="searchBuyer">
            {{order.buyer_username}}
          </span>
        </p>
      </div>
      <ul class="clearfix notMobile">
        <li class="business-name">
          <span>商家</span>
          <p><a :href="order.website" target="_blank">{{order.business_name}}</a></p>
        </li>
        <li>
          <span>创建日期</span>
          <p>{{order.create_time.replace(/\s.*/, '')}}</p>
        </li>
        <li style="position: relative;">
          <span>金额</span>
          <p>
            <el-popover
              placement="bottom"
              width="220"
              trigger="hover">
              <ul class="popover-price" v-if="real_price_info">
                <li><span>商品</span><del v-if="real_price_info.original_goods_price.value != real_price_info.goods_price.value">{{real_price_info.original_goods_price.currency_symbol}}{{real_price_info.original_goods_price.value}}</del> {{real_price_info.goods_price.currency_symbol}}{{real_price_info.goods_price.value}}</li>
                <li><span>消费税</span><del v-if="real_price_info.original_tax_price.value != real_price_info.tax_price.value">{{real_price_info.original_tax_price.currency_symbol}}{{real_price_info.original_tax_price.value}}</del> {{real_price_info.tax_price.currency_symbol}}{{real_price_info.tax_price.value}}</li>
                <li><span>商家运费</span><del v-if="real_price_info.original_transport_price.value != real_price_info.transport_price.value">{{real_price_info.original_transport_price.currency_symbol}}{{real_price_info.original_transport_price.value}}</del> {{real_price_info.transport_price.currency_symbol}}{{real_price_info.transport_price.value}}</li>
                <li><span>其他费用</span><del v-if="real_price_info.original_other_price.value != real_price_info.other_price.value">{{real_price_info.original_other_price.currency_symbol}}{{real_price_info.original_other_price.value}}</del> {{real_price_info.other_price.currency_symbol}}{{real_price_info.other_price.value}}</li>
                <li><span>商家小计</span><del v-if="real_price_info.original_subtotal_price.value != real_price_info.subtotal_price.value">{{real_price_info.original_subtotal_price.currency_symbol}}{{real_price_info.original_subtotal_price.value}}</del> {{real_price_info.subtotal_price.currency_symbol}}{{real_price_info.subtotal_price.value}}</li>
                <li><span>优惠码</span> {{real_price_info.coupon_text}}</li>
                <hr v-show="order.service_type==2" class="line">
                <li v-show="order.service_type==2"><span>国际运费</span><del v-if="real_price_info.international_transport_price.value != real_price_info.original_international_transport_price.value">{{original_international_transport_price_text}}</del> {{international_transport_price_text}}</li>
                <!--<li><span>实时汇率</span>{{$decimalFormat(real_price_info.rate,4)}}</li>
                <li><span>总计</span><del v-if="real_price_info.original_total_price.value != real_price_info.total_price.value">{{real_price_info.original_total_price.currency_symbol}}{{real_price_info.original_total_price.value}}</del> {{real_price_info.total_price.currency_symbol}}{{real_price_info.total_price.value}}</li>-->
              </ul>
              <a slot="reference">
                {{real_price_info?real_price_info.subtotal_price.currency_symbol:order.price_info.subtotal_price.currency_symbol}}{{real_price_info?real_price_info.subtotal_price.value:order.price_info.subtotal_price.value}}<i class="el-icon-caret-bottom"></i>
              </a>
            </el-popover>
          </p>
          <div class="offlineLabel" v-if="order.offline_payment == '1'">私下支付</div>
          <div v-if="order.status != 12 && order.status != 30 && order.status != 20 && order.fee_adjustment_list.length > 0 && order.offline_payment != '1'">
            <div class="unpaidlineLabel" v-if="order.fee_adjustment_list[0].status=='0'">
              <div >待支付</div>
            </div>
          </div>
        </li>
        <li>
          <span>寄至</span>
          <p>
            <el-popover
              placement="bottom"
              width="257"
              trigger="hover">
              <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
              v-if="order.address.country != '中国大陆(CN)'"
              v-clipboard:copy="order.address.county?order.address.first_name+' '+order.address.last_name+' '+order.address.address1+' '+order.address.address2+' '+order.address.county+','+order.address.city+','+order.address.province+' '+order.address.zip_code+' '+order.address.mobile:order.address.first_name+' '+order.address.last_name+' '+order.address.address1+' '+order.address.address2+' '+order.address.city+','+order.address.province+' '+order.address.zip_code+' '+order.address.mobile"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
                <img src="../../../assets/images/copy.png" v-if="!copyTxtSuccess" class="copy" alt=""> {{copyTxtSuccess?'已复制':'复制'}}
              </div>
              <div class="copyTxt" :class="{copyTxtSuccess:copyTxtSuccess}"
              v-if="order.address.country == '中国大陆(CN)'"
              v-clipboard:copy="order.address.county?order.address.last_name+order.address.first_name+' '+order.address.mobile+' '+order.address.province+order.address.city+order.address.county+' '+order.address.address1+' '+order.address.address2+' '+'邮编:'+order.address.zip_code:order.address.last_name+order.address.first_name+' '+order.address.mobile+' '+order.address.province+order.address.city+order.address.county+' '+order.address.address1+' '+'邮编:'+order.address.zip_code"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
                <img src="../../../assets/images/copy.png" class="copy" v-if="!copyTxtSuccess" alt=""> {{copyTxtSuccess?'已复制':'复制'}}
              </div>
              <SingleAddress :address="order.address" :order="order" :transportList="transportList" :isSingle="isSingle"></SingleAddress>
              <a slot="reference" v-if="order.address.country == '中国大陆(CN)'"><label style="font-weight:bold;">{{order.address.last_name}}</label><label>{{order.address.first_name}}</label><span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span><i class="el-icon-caret-bottom"></i></a>
              <a slot="reference" v-if="order.address.country != '中国大陆(CN)'">{{order.address.first_name}} {{order.address.last_name}}<span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span><i class="el-icon-caret-bottom"></i></a>
              <!--<a slot="reference" v-if="order.address.transport_or_not == 1">{{order.address.transport_company}}<span style="color:#333;" v-if="order.support_transport_service=='2'&&isSingle&&order.shipping_info&&order.shipping_info.length&&transportList.length" v-for="item in transportList"> | {{item}}</span> <i class="el-icon-caret-bottom"></i></a>-->
              <div class="copyTxt" :class="{copyIdCardSuccess:copyIdCardSuccess}"
              v-if="order.id_card_id!=0 && order.id_card_info"
              v-clipboard:copy="order.id_card_info.name+' '+order.id_card_info.id_card+' '+order.id_card_info.valid_date"
              v-clipboard:success="onCopyIdCard"
              v-clipboard:error="onError">
                <img src="../../../assets/images/copy.png" v-if="!copyIdCardSuccess" class="copy" alt=""> {{copyIdCardSuccess?'已复制':'复制'}}
              </div>
              <div class="id_card_div" v-if="order.id_card_id!=0 && order.id_card_info">
                <div class="bold"><i class="iconfont el-icon-joyordershenfenzhengrenzheng" style="margin-right:5px;"/>清关证件</div>
                <p>姓名：{{order.id_card_info.name}}</p>
                <p>身份证号：{{order.id_card_info.id_card}}</p>
                <p>有效日期：{{order.id_card_info.valid_date}}</p>
                <div style="width:100%;display: flex;align-content: space-between;margin-top:7px;">
                  <div class="id_card_img" style="margin-right:5px;" @click="saveIdCard('front_image_url',order.id_card_info.name)">
                    <img :src="order.id_card_info.front_image_url" />
                    <i class="iconfont el-icon-joyorderxiazai"></i>
                  </div>
                  <div class="id_card_img" @click="saveIdCard('back_image_url',order.id_card_info.name)">
                    <img :src="order.id_card_info.back_image_url" />
                    <i class="iconfont el-icon-joyorderxiazai"></i>
                  </div>
                </div>
              </div>
            </el-popover>
          </p>
        </li>
      </ul>
      <div class="isMobile">
        <span class="detail-button" @click="getGoodDetail()">订单详情</span>
        <span class="detail-text">订单#{{order.order_no}}</span>
        <p class="detail-time">{{order.create_time.replace(/\s.*/, '')}}</p>
      </div>
    </div>
    <div class="order-body">
      <ul>
        <li v-if=" order.type == 2 && order.status < 16 && order.goods_list.length==0" class="order-detail">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile">
                <div>
                  <p v-if="order.status == 11">待接单</p>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p v-if="order.fee_adjustment_list[0].status == 0">待支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 1">已支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 2">已取消</p>
                    <p v-if="order.fee_adjustment_list[0].status == 3">未退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 4">已退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 5">无需操作</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p v-if="order.status == 12">待支付</p>
                    <p v-if="order.status == 13">待下单</p>
                  </template>
                  <!--<template v-else-if="order.status == 13">
                    <p >待下单</p>
                  </template>-->
                  <p v-if="order.status == 14">下单中</p>
                  <p v-if="order.status == 15">待发货</p>
                </div>
                <div v-if="order.business_order_no" class="order-code notMobile">
                  <p style="margin-bottom: 10px;">商家订单号</p>
                  <a style="color:#333;">{{order.business_order_no}}</a>
                </div>
              </div>
              <div class="order-state isMobile">
                <div>
                  <p v-if="order.status == 11">待接单</p>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p v-if="order.fee_adjustment_list[0].status == 0">待支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 1">已支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 2">已取消</p>
                    <p v-if="order.fee_adjustment_list[0].status == 3">未退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 4">已退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 5">无需操作</p>
                  </template>
                  <template v-if="!order.fee_adjustment_list.length">
                    <p v-if="order.status == 12">待支付</p>
                    <p v-if="order.status == 13">待下单</p>
                  </template>
                  <!--<template v-else-if="order.status == 13">
                    <p >待下单</p>
                  </template>-->
                  <p v-if="order.status == 14">下单中</p>
                  <p v-if="order.status == 15">待发货</p>
                </div>
              </div>
              <div class="weeCtCoverBeforeDeal" v-if="order.voucher_list && order.voucher_list.length > 0 ">
                <div class="coverMore" v-if="order.voucher_list.length > 3"></div>
                <GeminiScrollbar forceGemini autoshow class>
                  <div v-if="order.status <= 15"
                          class="ctCover"
                          :style="{width: `${order.displayVoucherList.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.displayVoucherList"
                            :key="$index"
                    >
                    </div>
                  </div>
                  <div v-else
                          class="ctCover"
                          :style="{width: `${order.voucher_list.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.voucher_list"
                            :key="$index"
                    >
                    </div>
                  </div>
                </GeminiScrollbar>
              </div>
              
            </el-col>
            <el-col class="operation-container notMobile" :span="5">
              
            </el-col>
          </el-row>
        </li>
        <li v-for="(groupOrderLine, packageId) in order.groupOrderLines" :key="packageId" class="order-detail" v-if="order.goods_list&&order.goods_list.length">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile">
                <OrderState :isSingle="isSingle" :groupOrderLine="groupOrderLine" :order="order" :packageId="packageId" :trackTask="trackTask" :showPackstatus="true"></OrderState>
              </div>
              <div class="order-state isMobile" @click="getPackgeDetail(groupOrderLine,packageId)">
                <OrderState :isSingle="isSingle" :groupOrderLine="groupOrderLine" :order="order" :packageId="packageId" :trackTask="trackTask" :mobiletype="taskInfo.mobiletype"></OrderState>
                <span class="tabBar"><i class="el-icon-arrow-right"></i></span>
              </div>
              <ul>
                <li v-for="(line,index) in groupOrderLine" :key="index" class="order-line clearfix" @mouseover="hover(index,packageId)" @mouseout="hoverIndex = -1;packageIdIndex= -1" v-if="order.type==0">
                  <div class="img-container">
                    <a :href='line.website.substr(0,7).toLowerCase() == "https://" || line.website.substr(0,8).toLowerCase() == "https://" ? line.website : "https://"+ line.website' target="_blank">
                      <img v-if="line.picture" :src="line.picture"/>
                      <img v-else src="https://pic.joyorders.com/blank.png"/>
                      <span class="goodsNum" v-if="line.number>1">{{line.number}}</span>
                    </a>
                  </div>
                  <div class="order-des">
                    <p class="name"><a :href='line.website.substr(0,7).toLowerCase() == "http://" || line.website.substr(0,8).toLowerCase() == "https://"  ? line.website : "http://"+ line.website' target="_blank">{{line.name}}</a></p>
                    <!-- <p class="notMobile"><span>规格：</span>{{line.spec}}</p> -->
                    <div class="notMobile spec" v-show="formatSpec(line.spec,line)">
                      <span v-show="!line.isHideSpecLabel">规格：</span>
                      <span v-html="formatSpec(line.spec)"></span>
                    </div>
                    <div style="height:24px;" v-show="!formatSpec(line.spec)">
                    </div>
                    <div class="notMobile spec" v-show="line.sku && isSingle">
                      <span>货号：</span>
                      <span>{{line.sku}}</span>
                    </div>
                    <div style="height:24px;" v-show="!(line.sku && isSingle)">
                    </div>
                    <div v-if="line.discounted_price !== line.price" class="notMobile" style="display: flex;align-items: center;">
                      <a class="order-price">{{(line.discounted_price)|currency(order.currency_symbol)}}</a>
                      <del class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</del>
                    </div>
                    <div v-if="line.discounted_price == line.price" class="notMobile" style="display: flex;align-items: center;">
                      <p class="order-price"> {{(line.price)|currency(order.currency_symbol)}}</p>
                    </div>
                  </div>
                </li>
                <li class="order-line clearfix" v-for="(line,index) in groupOrderLine[0].image_info" :key="index">
                  <div class="img-container">
                    <img v-if="line.image" :src="line.image"/>
                    <img v-else src="https://pic.joyorders.com/blank.png"/>
                  </div>
                  <div class="order-des">
                    <p class="name" v-if="line.remark">{{line.remark}}</p>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col class="operation-container notMobile" :span="5">
              
            </el-col>
          </el-row>
        </li>
        <li class="order-detail" v-if="order.type == 2 && order.status >= 16 && order.goods_list.length==0 && order.good_image_list && order.good_image_list.length">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile">
                <div>
                  <p v-if="order.status == 20">已完成</p>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p v-if="order.fee_adjustment_list[0].status == 0">待支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 1">已支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 2">已取消</p>
                    <p v-if="order.fee_adjustment_list[0].status == 3">未退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 4">已退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 5">无需操作</p>
                  </template>
                  <template v-else-if="order.status == 30">
                    <p >已取消</p>
                  </template>
                  <p v-if="order.status == 14">下单中</p>
                  <p v-if="order.status == 15">待发货</p>
                </div>
                <div v-if="order.business_order_no" class="order-code notMobile">
                  <p style="margin-bottom: 10px;">商家订单号</p>
                  <a style="color:#333;">{{order.business_order_no}}</a>
                </div>
              </div>
              <div class="order-state isMobile">
                <div>
                  <p v-if="order.status == 20">已完成</p>
                  <template v-if="order.fee_adjustment_list && order.fee_adjustment_list.length && order.fee_adjustment_list[0]">
                    <p v-if="order.fee_adjustment_list[0].status == 0">待支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 1">已支付</p>
                    <p v-if="order.fee_adjustment_list[0].status == 2">已取消</p>
                    <p v-if="order.fee_adjustment_list[0].status == 3">未退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 4">已退款</p>
                    <p v-if="order.fee_adjustment_list[0].status == 5">无需操作</p>
                  </template>
                  <template v-else-if="order.status == 30">
                    <p >已取消</p>
                  </template>
                  <p v-if="order.status == 14">下单中</p>
                  <p v-if="order.status == 15">待发货</p>
                </div>
              </div>
              <div class="weeCtCoverBeforeDeal" v-if="order.voucher_list && order.voucher_list.length > 0 ">
                <div class="coverMore" v-if="order.voucher_list.length > 3"></div>
                <GeminiScrollbar forceGemini autoshow class>
                  <div v-if="order.status <= 15"
                          class="ctCover"
                          :style="{width: `${order.displayVoucherList.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.displayVoucherList"
                            :key="$index"
                    >
                    </div>
                  </div>
                  <div v-else
                          class="ctCover"
                          :style="{width: `${order.voucher_list.length * (screenWidthWee > 1024 ? 130 : 90) + 15}px`}"
                          @click="showOrderVoucher"
                  >
                    <div
                            class="cover"
                            :style="{background: `url('${item.url}') center no-repeat`}"
                            v-for="(item, $index) in order.voucher_list"
                            :key="$index"
                    >
                    </div>
                  </div>
                </GeminiScrollbar>
              </div>
              
            </el-col>
          </el-row>
        </li>
        <li class="order-detail" v-if="order.type==2 && order.status==15 && order.goods_list.length && order.goods_list[0].package_id">
          <el-row>
            <el-col class="line-list clearfix" :xs="24" :lg="19" :md="18" :sm="24">
              <div class="order-state notMobile">
                <OrderState :isSingle="isSingle" :groupOrderLine="constantGroupOrderLine" :order="order" :trackTask="false" :showPackstatus="false"></OrderState>
              </div>
              <div class="constantGroupOrderLine">订单下有未发货商品</div>
            </el-col>
          </el-row>
        </li>
      </ul>
      <div class="order-foot isMobile">
        <span style="float:left;">总计</span>
        <span class="foot-price">
          <a  v-if="isSingle && order.fee_adjustment_list.length == 0">{{order.total_amount | currency(order.currency_symbol)}}</a>
          <a  v-if="isSingle && order.fee_adjustment_list.length > 0">{{$decimalFormat(Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee),2) | currency(order.currency_symbol)}}</i></a>
          <a  v-if="!isSingle && order.fee_adjustment_list.length == 0">{{order.rmb_total_amount | currency('¥')}}</a>
          <a  v-if="!isSingle && order.fee_adjustment_list.length > 0">{{$decimalFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate) + Number(order.fee_adjustment_list[0].package_forwarding_fee)),2) | currency('¥')}}</a>
        </span>
      </div>
    </div>
    <el-dialog v-if="showPackge" class="el-dialog-sm el-dialog-sm-h3 mobile-order-detail" :close-on-click-modal="false"  :visible.sync="showPackge" width="90%"  @close="toggleBody(0)">
      <h1 style="" class="detail-title">包裹详情</h1>
      <div class="detail-body">
        <h2>包裹状态</h2>
        <div class="mobile-order-state">
          <OrderState :isSingle="isSingle" :groupOrderLine="groupOrderLine_temporary" :trackTask="trackTask" :order="order" :packageId="packageId_temporary" :mobiletype="taskInfo.mobiletype" :showPackstatus="true"></OrderState>
        </div>
        <p v-if="order.business_order_no && !trackTask">商家订单号{{order.business_order_no}}</p>
      </div>
      <div class="detail-body">
        <ul class="buyContent">
          <li class="clearfix" v-for="(goods,index) in groupOrderLine_temporary" :key="index">
            <div class="content-container">
              <div class="clearfix">
                <div class="img-container">
                  <a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">
                    <img v-if="goods.picture" :src="goods.picture"/>
                    <img  v-else src="https://pic.joyorders.com/blank.png"/>
                  </a>
                </div>
                <div class="line-des">
                  <p class="name"><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></p>
                  <!-- <p><span>规格：</span>{{goods.spec}}</p> -->
                  <div class="spec">
                    <span>规格：</span>
                    <span v-html="formatSpec(goods.spec)"></span>
                  </div>
                  <div v-if="goods.discounted_price !== goods.price">
                    <a class="order-price">{{(goods.discounted_price)|currency(order.currency_symbol)}}</a>
                    <del class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</del>
                  </div>
                  <div v-if="goods.discounted_price == goods.price">
                    <p class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="detail-body">
        <h2>寄至</h2>
        <SingleAddress :address="order.address"></SingleAddress>
      </div>
    </el-dialog>
    <el-dialog v-if="showDetail" class="el-dialog-sm el-dialog-sm-h3 mobile-order-detail orderDetail" :close-on-click-modal="false"  :visible.sync="showDetail" width="90%"  @close="toggleBody(0)">
      <h1 style="" class="detail-title">订单详情</h1>
      <div class="isMobile">
        <div class="suspension">

          <div class="flexBtn" style="margin-top:10px;" v-if="order.status == 11&&isSingle">
            <div @click="take_by_single()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >确认接单</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status == 13&&isSingle">
            <div @click="begin()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >开始下单</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if=" order.status == 14 && ( (order.fee_adjustment_list[0] && order.fee_adjustment_list[0].status == 1) || !(order.fee_adjustment_list[0] && order.fee_adjustment_list[0].unpaid_fee_rmb)) &&isSingle">
            <div @click="showUploadOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >上传下单信息</div>
            </div>
          </div>
          <AddressDialog v-if="['11'].indexOf(order.status) > -1 && !isSingle"  :address-id="order.address_id" v-on:success="updateAddress" v-on:complete="complete" style="display:block;margin-top: 10px;">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >更改地址</div>
          </AddressDialog>
          <OrderCancelDialog v-if="['11', '13'].indexOf(order.status) > -1&&!isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo">
            <!-- <div   v-if="!trackTask"> -->
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消任务</div>
            <!-- </div> -->
          </OrderCancelDialog>
          <OrderCancelDialog v-if="['11','12', '13','14'].indexOf(order.status) > -1&&isSingle" style="margin-top:10px;" class="flexBtn" :mobiletype="taskInfo.mobiletype" :isSingle="isSingle" :order="order" v-on:complete="complete" @refresh="updatePriceInfo">
            <!-- <div   v-if="!trackTask"> -->
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消任务</div>
            <!-- </div> -->
          </OrderCancelDialog>
          <div class="flexBtn" style="margin-top:10px;" v-if="['11'].indexOf(order.status) > -1 && !isSingle">
            <div @click="copyOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >修改地址</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="!trackTask && order.type!=2">
            <div @click="copyOrder()">
              <i class="el-icon-copy-document operationIco"></i>
              <div class="operationBtn" >复制任务</div>
            </div>
          </div>
          <OrderShare :order="order" style="margin-top:10px;" class="flexBtn"  :mobiletype="taskInfo.mobiletype" v-if="order.status == 12">
            <i class="el-icon-share operationIco"></i>
            <div class="operationBtn" >分享任务</div>
          </OrderShare>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status ==12">
            <div @click="editOrder()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >修改任务</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status==15||order.status==16||order.status==20 || order.type == 2">
            <div @click="showOrderVoucher()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >下单凭证</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status ==15&&isSingle">
            <div @click="showExpress()">
              <i class="el-icon-edit-outline operationIco"></i>
              <div class="operationBtn" >上传商家物流</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status != 13 && order.status != 12 && order.status != 11&&order.status!=30&&isSingle&&order.type==0">
            <div @click="showProductCancel()">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消商品</div>
            </div>
          </div>
          <div class="flexBtn" style="margin-top:10px;" v-if="order.status != 13 && order.status != 12 && order.status != 11&&order.status!=30&&isSingle&&order.type==2&&order.status!=16">
            <div @click="showProductCancel()">
              <i class="el-icon-circle-close operationIco"></i>
              <div class="operationBtn" >取消商品</div>
            </div>
          </div>
          <div v-if="isSingle && order.status != '30' && order.status != '20'" style="margin-top:9px;" class="flexBtn">
            <div @click="openModify()">
              <span class="moneyIco operationIco"></span>
              <div class="operationBtn" >修改费用</div>
            </div>
          </div>
          <div v-if="isSingle && order.status == '30' && showRefundTip" style="margin-top:9px;" class="flexBtn">
            <div @click="openModify()">
              <span class="moneyIco operationIco"></span>
              <div class="operationBtn" >退款</div>
            </div>
          </div>

        </div>
      </div>

      <div class="detail-body">
        <p>订单#{{order.order_no}}</p>
        <p>商家{{order.business_name}}</p>
        <p>创建日期{{order.create_time.replace(/\s.*/, '')}}</p>
      </div>
      <div class="detail-body">
        <h2>订单总计</h2>
        <ul class="popover-price">
          <li><span>商品</span> {{order.total_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>消费税</span><del v-if="order.fee_adjustment_list[0].original_tax_fee != order.fee_adjustment_list[0].tax_fee">{{order.fee_adjustment_list[0].original_tax_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].tax_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>消费税</span> {{order.tax_amount | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>商家运费</span><del v-if="order.fee_adjustment_list[0].original_transport_fee != order.fee_adjustment_list[0].transport_fee">{{order.fee_adjustment_list[0].original_transport_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].transport_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>商家运费</span> {{order.transport_amount | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>其他费用</span><del v-if="order.fee_adjustment_list[0].original_other_fee != order.fee_adjustment_list[0].other_fee">{{order.fee_adjustment_list[0].original_other_fee | currency(order.currency_symbol)}}</del> {{order.fee_adjustment_list[0].other_fee | currency(order.currency_symbol)}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>其他费用</span> {{order.other_amount | currency(order.currency_symbol)}}</li>
          <li><span>汇率</span> {{$decimalFormat(+order.conditions.rate,4)}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>商家小计</span> {{$decimalFormat((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee)),2) | currency(order.currency_symbol)}}/{{$decimalFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate)),2) | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>商家小计</span> {{order.total_amount | currency(order.currency_symbol)}}/{{order.rmb_total_amount | currency('¥')}}</li>
          <li><span>优惠码</span> {{order.coupon_text}}</li>
          <hr class="line">
          <li v-if="order.fee_adjustment_list.length > 0"><span>国际运费</span><del v-if="order.fee_adjustment_list[0].original_package_forwarding_fee != order.fee_adjustment_list[0].package_forwarding_fee">{{order.fee_adjustment_list[0].original_package_forwarding_fee | currency('¥')}}</del> {{order.fee_adjustment_list[0].package_forwarding_fee  | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>国际运费</span> {{order.transport_amount_rmb | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><span>总计</span> {{$decimalFormat(((Number(order.total_fee) + Number(order.fee_adjustment_list[0].tax_fee) + Number(order.fee_adjustment_list[0].transport_fee) + Number(order.fee_adjustment_list[0].other_fee))*Number(order.conditions.rate) + Number(order.fee_adjustment_list[0].package_forwarding_fee)),2) | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0"><span>总计</span> {{order.rmb_total_amount | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status=='0'"><span>待支付</span> {{order.fee_adjustment_list[0].unpaid_fee_rmb  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status=='3'"><span>待退款</span> {{order.fee_adjustment_list[0].unpaid_fee_rmb.replace('-','')  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length > 0"><div v-if="order.fee_adjustment_list[0].status!='0' && order.fee_adjustment_list[0].status!='3'"><span>待支付</span> {{0.00  | currency('¥')}}</div></li>
          <li v-if="order.fee_adjustment_list.length == 0 && order.status == '12'"><span>待支付</span> {{order.rmb_total_amount | currency('¥')}}</li>
          <li v-if="order.fee_adjustment_list.length == 0 && order.status != '12'"><span>待支付</span> {{0.00 | currency('¥')}}</li>
        </ul>
      </div>
      <div class="detail-body">
        <h2>寄至</h2>
        <SingleAddress :address="order.address"></SingleAddress>
      </div>
      <div class="detail-body">
        <h2>响应时间</h2>
        <p v-if="order.status < 13">{{order.conditions.response_hours}}</p>
        <p v-if="(order.status == 13 || order.status == 14) && this.order.conditions.response_hours.indexOf('小时内响应') > -1 && this.order.take_time">下单还剩 {{order.take_time}}</p>
        <p v-if="(order.status == 13 || order.status == 14) && this.order.conditions.response_hours == '尽快响应' && this.order.take_time">尽快响应</p>
      </div>
      <div class="detail-body">
        <h2>下单说明</h2>
        <p v-if="order.buyer_account_id > 0 && isSingle && order.buyer.email" class="clearfix" style="margin-top: 5px;">
          <span style="display:inline-block;float:left;margin-right:5px;">
            联系邮箱:
          </span>
          <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
            {{order.buyer.email}}
          </span>
        </p>
        <p style="margin-top: 5px;">
          <span style="display:inline-block;float:left;margin-right:5px;">
            缺货处理：
          </span>
          <span style="display:inline-block;width:160px;float:left;word-break:break-all;">
            {{lackDisplay[order.conditions.check_full_goods?order.conditions.check_full_goods:0]}}
          </span>
        </p>

        <p v-if="order.realRemark" class="clearfix" style="margin-top: 5px;">
          <span style="display:inline-block;float:left;">备注：</span>
          <span style="display:inline-block;width:140px;float:left;">{{order.realRemark}}</span>
        </p>
        <p  class="clearfix" style="margin-top: 5px;">
          <span v-if="order.support_transport_service == '1'">无需下单人提供转运服务</span>
          <span v-if="order.support_transport_service == '2'">需下单人提供转运服务</span>
        </p>
      </div>
    </el-dialog>
    <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3"  :lock-scroll="true" :visible.sync="completion" width="90%" @close="closeCompletion()">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">{{operationType}}</h1>
        <p v-if="status && status != 12&&refund!=null">若非私下付款,{{refund}}元退款将于24小时内原路返回至{{name}}的支付账户。<span v-if="showRefundTip">订单中还有(转费/其他费用/转运费)未退款,可前往'任务总计'退款</span></p>
        <p v-if="status && status != 12&&refund==null">请通过修改费用退还商品金额。<span v-if="showRefundTip">订单中还有(转费/其他费用/转运费)未退款,可前往'订单总计'退款</span></p>
        <p v-if="!status && !operation && !confirm && !isBuyAgain">您的收货地址已经更换</a></p>
        <p v-if="!status && !operation && confirm">若非私下付款,订单金额已进入下单人账户</a></p>
        <!--<p class="tip" style="margin-top: 10px;" v-if="!status && operation">
          请将商家邮件转发至 <a href="mailto:OrderTrack@joyorders.com">OrderTrack@joyorders.com</a>
        </p>-->
      </div>
    </el-dialog>
    <el-dialog v-if="isBuy" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="isBuy" width="90%" @close="showForm = false">
      <h1 class="buyTitle">再次购买</h1>
      <div>
        <p class="website-name">{{order.business.name}}</p>
        <p class="website-url" v-for="(b,index) in order.business.website.split(',')" :key="index">{{b}}</p>
      </div>
      <ul class="buyContent">
        <li class="clearfix">
          <div class="content-container">
            <div class="clearfix">
              <div class="img-container">
                <a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">
                  <img v-if="goods.picture" :src="goods.picture"/>
                  <img  v-else src="https://pic.joyorders.com/blank.png"/>
                </a>
              </div>
              <div class="line-des">
                <p class="name"><a :href='goods.website.substr(0,7).toLowerCase() == "http://" || goods.website.substr(0,8).toLowerCase() == "https://" ? goods.website : "http://"+ goods.website' target="_blank">{{goods.name}}</a></p>
                <!-- <p><span>规格：</span>{{goods.spec}}</p> -->
                <div class="spec">
                  <span>规格：</span>
                  <span v-html="formatSpec(goods.spec)"></span>
                </div>
                <div v-if="goods.discounted_price !== goods.price">
                  <a class="order-price">{{(goods.discounted_price)|currency(order.currency_symbol)}}</a>
                  <del class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</del>
                </div>
                <div v-if="goods.discounted_price == goods.price">
                  <p class="order-price"> {{(goods.price)|currency(order.currency_symbol)}}</p>
                </div>
                <el-select v-model="form.number" class="inline-block">
                  <el-option
                    v-for="item in 100"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="!isSingle" class="block" type="primary" @click="submit(order,goods)"><div class="addCart"></div>加入购物车</el-button>
        <el-button v-if="isSingle" class="block" type="primary" @click="taskInfoSubmit(order,goods)"><div class="addCart"></div>加入购物车</el-button>
      </div>
      <el-dialog
        width="30%"
        :visible.sync="warning"
        append-to-body>
        <h1 style="text-align:center; padding: 0 0 30px;">提示</h1>
        <p>该商品与购物车内已存在商品的商家网址不一样,继续操作将覆盖购物车内商品</p>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="isSingle" class="block" type="primary" @click="coverSubmit(order,goods)">确认</el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog v-if="showModify" class="el-dialog-sm" :close-on-click-modal="false" :visible.sync="showModify" :lock-scroll="true" width="90%" @close="step = 1">
      <h3 class="text-center"><i v-if="step > 1" class="el-icon-arrow-left back" @click="step--"></i>{{modifyTitle}}</h3>
      <div v-if="step == 1">
        <el-form ref="modifyPrice" :model="modifyPrice" :rules="rules" class="dialog-form">
          <ul class="error-messages" v-if="!isEmptyErrors">
            <li v-for="error in errors">{{error[0].message}}</li>
          </ul>
          <el-form-item label="" class="modify-price">
            <div v-if="!editTotalFee && order.type == 2">
              <div >
                <div>
                  <span>商品</span>{{order.total_amount | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="editTotalFee" :reg="/^\d+\.?\d{0,2}$/" model="total_amount" :object="modifyAmount" placeholder="商品" v-on:blur="editAmount"></YueDanIpt>
            </div>
            <div v-if="!editTotalFee && order.type != 2">
              <div >
                  <span>商品</span>{{order.total_fee | currency(order.currency_symbol)}}
              </div>
              <YueDanIpt v-if="editTotalFee" :reg="/^\d+\.?\d{0,2}$/" model="total_fee" :object="modifyAmount" placeholder="商品" v-on:blur="editAmount"></YueDanIpt>
            </div>
          </el-form-item>
          <el-form-item label="" prop="tax_fee" v-if="order.type!=2">
            <div v-if="!showRefundTip">
              <div v-if="order.status>14" class="modify">
                <div>
                <span>消费税</span>{{modifyPrice.tax_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="order.status<=14" :reg="/^\d+\.?\d{0,2}$/" model="tax_fee" :object="modifyPrice" placeholder="消费税" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
            <div v-if="showRefundTip">
              <div v-if="Number(defaultModify.tax_fee) == 0" class="modify">
                <div>
                <span>消费税</span>{{modifyPrice.tax_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="Number(defaultModify.tax_fee) != 0" :reg="/^\d+\.?\d{0,2}$/" model="tax_fee" :object="modifyPrice" placeholder="消费税" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
          </el-form-item>
          <el-form-item label="" prop="transport_fee" v-if="order.type!=2">
            <div v-if="!showRefundTip" >
              <div v-if="order.status>14" class="modify">
                <div>
                <span>商家运费</span>{{modifyPrice.transport_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="order.status<=14" :reg="/^\d+\.?\d{0,2}$/" model="transport_fee" :object="modifyPrice" placeholder="商家运费" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
            <div v-if="showRefundTip">
              <div v-if="Number(defaultModify.transport_fee) == 0" class="modify">
                <div>
                <span>商家运费</span>{{modifyPrice.transport_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="Number(defaultModify.transport_fee) != 0" :reg="/^\d+\.?\d{0,2}$/" model="transport_fee" :object="modifyPrice" placeholder="商家运费" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
          </el-form-item>
          <el-form-item label="" prop="other_fee" v-if="order.type!=2">
            <div v-if="!showRefundTip">
              <div v-if="order.status>14  && !showRefundTip" class="modify">
                <div>
                  <span>其他费用</span>{{modifyPrice.other_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="order.status<=14 || showRefundTip" :reg="/^\d*\.?\d{0,2}$/" model="other_fee" :object="modifyPrice" placeholder="其他费用" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
            <div v-if="showRefundTip">
              <div v-if="Number(defaultModify.other_fee) == 0" class="modify">
                <div>
                  <span>其他费用</span>{{modifyPrice.other_fee | currency(order.currency_symbol)}}
                </div>
              </div>
              <YueDanIpt v-if="Number(defaultModify.other_fee) != 0" :reg="/^\d*\.?\d{0,2}$/" model="other_fee" :object="modifyPrice" placeholder="其他费用" :append="order.currency" v-on:blur="modifyBlur"></YueDanIpt>
            </div>
          </el-form-item>
          <div class="modify-price">
            <div>
              <span>汇率</span>{{order.conditions.rate}}
            </div>
            <div v-if="order.type != 2">
              <span>商家小计</span>{{totalBusinessPrice | currency(order.currency_symbol)}}/{{$decimalFormat((Number(totalBusinessPrice)*Number(order.conditions.rate)),2) | currency('¥')}}
            </div>
            <div v-else>
              <span>商家小计</span>{{Number(order.total_amount) | currency(order.currency_symbol)}}/{{Number(order.original_rmb_total_amount) | currency('¥')}}
            </div>
          </div>
          <div class="modify-price">
            <div>
              <span>服务费</span>{{order.service_amount | currency(order.currency_symbol)}}
            </div>
          </div>
          <div v-if="order.service_type != 1" class="modify-price">
            <div v-if="!showRefundTip">
              <div v-if=" order.type == 2 " >
                <div v-if="order.transport_amount_charge_type == 2" >
                 <span>国际运费</span>包邮
                </div>
                <div v-if="order.transport_amount_charge_type == 3" >
                  <span>国际运费</span>{{order.package_forwarding_fee | currency('¥')}}
                </div>
              </div>
              <YueDanIpt v-if="order.type == 2 && order.transport_amount_charge_type == 1" :reg="/^\d*\.?\d{0,2}$/"  model="package_forwarding_fee" :object="modifyPrice" placeholder="国际运费" :append="'CNY'" v-on:blur="modifyBlur"/>
              <div v-if=" order.type != 2 && Number(defaultModify.package_forwarding_fee) == 0" >
                <div v-if="order.transport_amount_charge_type == 2" >
                 <span>国际运费</span>包邮
                </div>
                <div v-if="order.transport_amount_charge_type == 3" >
                  <span>国际运费</span>{{order.package_forwarding_fee | currency('¥')}}
                </div>
              </div>
              <YueDanIpt v-if="order.type != 2 && order.transport_amount_charge_type == 1" :reg="/^\d*\.?\d{0,2}$/"  model="package_forwarding_fee" :object="modifyPrice" placeholder="国际运费" :append="'CNY'" v-on:blur="modifyBlur"/>

            </div>
          </div>
          <div class="modify-price" >
            <div>
              <span>总计</span>{{totalPrice | currency('¥')}}
            </div>
            <div v-if="Number(needPaid)>0"><span>待支付</span> {{needPaid  | currency('¥')}}</div>
            <div v-if="Number(needPaid)<0"><span>待退款</span> {{needPaid.replace('-','')  | currency('¥')}}</div>
            <div v-if="Number(needPaid)==0 && showRefundTip"><span>待退款</span> {{needPaid  | currency('¥')}}</div>
            <div v-if="Number(needPaid)==0 && !showRefundTip"><span>待支付</span> {{needPaid  | currency('¥')}}</div>

          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="block" type="primary" style="margin-bottom:30px;" @click="nextStep()">确 定</el-button>
        </div>
      </div>
      <div v-if="step == 2">
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)>0">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)+Number(returnAmount)>0">费用修改后,买单人需支付{{Number(needPaid)+Number(returnAmount)}}元。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)<0">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)+Number(returnAmount)<0">费用修改后,{{$decimalFormat((Number(needPaid)+Number(returnAmount)),2).replace('-','')}}元将退还买单人。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && showRefundTip">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)+Number(returnAmount)==0 && showRefundTip">费用修改后,{{needPaid.replace('-','')}}元将退还买单人。</h3>
        <!-- <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)==0 && !showRefundTip">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3> -->
        <h3 class="text-center" style="margin-bottom:30px;font-size:16px;line-height:2;" v-if="Number(needPaid)+Number(returnAmount)==0 && !showRefundTip">费用修改后,买单人需支付{{needPaid.replace('-','')}}元。</h3>
        <el-button class="block" style="margin-bottom:30px;" type="primary" @click="submitModify()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="modifySuccess" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="modifySuccess" width="90%" @close="showForm = false">
      <div class="text-center redirct">
        <p><i class="ico ico-paysucces completion"></i></p>
        <h1 style="padding: 60px 0 25px;">{{modifyTitle}}成功</h1>
        <p v-if="Number(needPaid)<0">已邮件通知买单人,{{needPaid.replace('-','')}}元退款将于10分钟内退款至买单人的支付账户。</p>
        <p v-if="Number(needPaid)>0">已邮件通知买单人,{{needPaid.replace('-','')}}元待支付。</p>
        <p v-if="Number(needPaid)==0 && showRefundTip">已邮件通知买单人,{{needPaid.replace('-','')}}元退款将于10分钟内退款至买单人的支付账户。</p>
        <p v-if="Number(needPaid)==0 && !showRefundTip">已邮件通知买单人,{{needPaid.replace('-','')}}元待支付。</p>
      </div>
    </el-dialog>
    <el-dialog v-if="showCopy" class="el-dialog-sm el-dialog-sm-h3" center :close-on-click-modal="false" :visible.sync="showCopy" width="90%" @close="showCopy = false">
      <div class="text-center">
        <h1 style="padding: 10px 0 30px;">确定复制该任务?</h1>
        <el-button @click="showCopy = false">取 消</el-button>
        <el-button type="primary" @click="copyOrderSuccess()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog width="30%" :close-on-click-modal="false" :visible.sync="offline" @close="offLine = false">
      <h1 style="text-align:center; padding: 0 0 30px;">提示</h1>
      <p>此下单任务为私下支付, 请确认收到付款再下单</p>
      <div slot="footer" class="dialog-footer" style="margin-top:10px;">
        <el-button @click="offline = false">取消</el-button>
        <el-button type="primary" @click="Submit()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog class="customDialog" width="300px" style="text-align:center;" :close-on-click-modal="false" :visible.sync="trackVisible" @close="trackVisible = false">
      <img :src="src" />
    </el-dialog>
    <OrderVoucher @selectProductImage="selectProductImage" :isSingle="isSingle" :needChoose="needChooseImage" :order="order" style="display:block;"></OrderVoucher>

    <AddressDialog v-if="['11'].indexOf(order.status) > -1 && !isSingle"  :address-id="order.address_id" v-on:success="updateAddress" v-on:complete="complete" style="display:block;margin-top: 10px;" :order="order"></AddressDialog>
    <vue-canvas-poster :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
  </div>
</template>

<script>
import OrderVoucher from './OrderVoucher'
import AddressDialog from '../../publish_task/address/AddressDialog'
import SingleAddress from '../../publish_task/address/SingleAddress'
import OrderState from './OrderState'
import api from '../../../services/api.js'
import ChatContainer from '../../../components/chat/ChatContainer'
import YueDanIpt from '../../../components/YueDanIpt'
import Clipboard from 'clipboard'
import { lackDisplay,specOrder,SPEC_MAPPER } from '../../../services/constant.js'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'Order',
  props: ['order', 'bussinessList', 'singleList', 'isSingle', 'trackTask'],
  components: {
    SingleAddress: SingleAddress,
    OrderState: OrderState,
    ChatContainer,
    AddressDialog: AddressDialog,
    YueDanIpt: YueDanIpt,
    OrderVoucher: OrderVoucher
  },
  computed: {
    original_international_transport_price_text(){
      switch(+this.real_price_info.original_international_transport_price.charge_type){
        case 1:
          return '实收 '+((+this.real_price_info.original_international_transport_price.value)?this.real_price_info.original_international_transport_price.currency_symbol+this.real_price_info.original_international_transport_price.value:'待计算');
        case 2:
          return '包邮';
        case 3:
          return this.real_price_info.original_international_transport_price.currency_symbol+this.real_price_info.original_international_transport_price.value;
      }
    },
    international_transport_price_text(){
      switch(+this.real_price_info.international_transport_price.charge_type){
        case 1:
          return '实收 '+((+this.real_price_info.international_transport_price.value)?this.real_price_info.international_transport_price.currency_symbol+this.real_price_info.international_transport_price.value:'待计算');
        case 2:
          return '包邮';
        case 3:
          return this.real_price_info.international_transport_price.currency_symbol+this.real_price_info.international_transport_price.value;
      }
    },
    taskInfo () {
	    return this.$store.state.taskInfo
    },
    nim () {
      return this.$store.state.nim
    }
  },
  data () {
    var checkIsPrice = (rule, value, callback) => {
      if (value && (isNaN(value) || value < 0)) {
        callback(new Error('请输入正确的金额'))
      } else {
        callback()
      }
    }
    return {
      lackDisplay:lackDisplay,
      real_price_info:null,
      constantGroupOrderLine:[{
        status:1
      }],
      trackVisible:false,
      painting:{
        width:`250px`,
        height:`400px`,
        background: '#fff',
        views: [
          {
            type: 'image',
            url: '',
            css: {
              width:`250px`,
              height:`250px`,
              mode:'aspectFill',
              left:'0',
              top: '0'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，跟踪包裹 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'280px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              } 
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'330px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              } 
          },
          /*{
            type: 'text',
            text: '',
            css: 
              {
                top:'360px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
              } 
          },*/
        ],
      },
      src:'',
      needChooseImage: false, // 显示选中图片
      editTotalFee: false, // 商品金额可编辑
      offline: false, // 线下支付弹框
      isOffLine: false, // 是否线下支付
      copyTxtSuccess: false,
      copyIdCardSuccess:false,
      transportList: [],
      packageIdIndex: -1,
      hoverIndex: -1,
      modifyTitle: '',
      showRefundTip: false,
      showCopy: false,
      groupOrderLine_temporary: null,
      packageId_temporary: null,
      showPackge: false,
      showDetail: false,
      screenWidth: document.body.clientWidth,
      screenWidthWee: document.body.clientWidth,
      mobiletype: false,
      step: 1,
      modifySuccess: false,
      innerVisible: false,
      fee_adjustment_list: [],
      loading: false,
      dialogFormVisible: false,
      errors: null,
      isEmptyErrors: true,
      showModify: false,
      currentOrder: {},
      totalProductPrice: null,
      totalBusinessPrice: null,
      totalPrice: null,
      needPaid: null,
      returnAmount: '0.00',
      timer: null,
      completion: false,
      status: null,
      operationType: '', // 操作类别
      type: '', // 商品or任务
      refund: '', // 退款
      name: '',
      operation: null, // 操作
      confirm: null, // 订单确认完成
      isBuy: false, // 再次购买
      isBuyAgain: false, // 再次购买是否成功
      warning: false, // 警告弹框
      goods: '',
      businessList: [],
      env: window.env,
      form: {
        good_id: '',
        name: '',
        website: '',
        spec: '',
        price: '',
        picture: '',
        discounted_price: '',
        number: 1,
        currency: null,
        currency_symbol: null
      }, // 再次购买信息
      modifyPrice: {
        order_id: '',
        offline_payment: '0',
        tax_fee: '0',
        transport_fee: '0',
        other_fee: '0',
        package_forwarding_fee: '0'
      },
      defaultModify: {
        tax_fee: '0',
        transport_fee: '0',
        other_fee: '0',
        package_forwarding_fee: '0'
      },
      modifyAmount: {
        total_amount: ''
      },
      rules: {
        tax_fee: [
          { required: true, message: '消费税是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        transport_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        other_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ],
        package_forwarding_fee: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' },
          { validator: checkIsPrice, trigger: 'blur' }
        ]
      },
      account_id:this.$localStorage.get('account_id')
    }
  },
  created () {
    let that = this
    this.real_price_info=JSON.parse(JSON.stringify(this.order.price_info));
    this.initData()
    window.onresize = () => {
      that.screenWidthWee = document.body.clientWidth
    }
  },
  methods: {
    searchBuyer(){
      this.$emit('searchBuyer',this.order.buyer_username)
    },
    formatStatus(status){
      switch(status){
        case 0:
          return '未知';
        case 15:
          return '待发货';
        case 16:
          return '已发货';
        case 30:
          return '已取消';
        case 40:
          return '联系客服';
        case 50:
          return '已退货';
      }
    },
    callbackPackage(){
      this.$confirm('确认撤回发货吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        let params={order_id: +this.order.id}
        api.post(this, {
              path: 'order.php?api=cancel_delivery_goods',
              data: params,
              loading: 'loading'})
        .then((res)=>{
          console.log(res)
          if (res.body.status == 'ok') {
            for(let key in this.order.groupOrderLines){
              this.order.groupOrderLines[key].forEach((g)=>{
                g.status='0'
              })
            } 
            this.order.status = '15';
          }
        })
      }).catch(() => {
                   
      });
    },
    isShowModifyOrdeInfo(){
      if(this.order.groupOrderLines){
        let r=false;
        for(let key in this.order.groupOrderLines){
            if(this.order.groupOrderLines[key][0].status==1 || this.order.groupOrderLines[key][0].status==4)
              r=true;
        }       
        return r;
      }
      else{
        return false;
      }
    },
    isShowCallbackPackage(){
      if(this.order.groupOrderLines){
        let r=false;
        for(let key in this.order.groupOrderLines){
            if(this.order.groupOrderLines[key][0].status==4)
              r=true;
        }       
        return r;
      }
      else{
        return false;
      }
    },
    updatePriceInfo(data){
      console.log('updatepriceinfo')
      this.$emit('refresh',{order:this.order,price_info:data})
    },
    saveIdCard(prop,name){
      let url=this.order.id_card_info[prop]
      var x=new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e){
          var url = window.URL.createObjectURL(x.response)
          var a = document.createElement('a');
          a.href = url
          let p=prop.split('_')[0]=='front'?'Front':'Back'
          a.download = name+p+".jpg"
          a.click()
      }
      x.send();
    },
    openTrack(){
      this.trackVisible=true;
      this.generateQrCode();
    },
    generateQrCode(){
      let params={page: 'pages/order/orderDetail/orderDetail',
						is_hyaline: true,
						scene: this.order.id}
        api.post(this, {
            path: 'good.php',
            data: params,
            loading: 'loading',
            api: 'create_qr_code'
        }).then((res)=>{
          if(this.order.goods_list&&this.order.goods_list.length){
            if(this.order.type==0)
              this.$set(this.painting.views[0], 'url', this.order.goods_list[0].picture);
            else
              this.$set(this.painting.views[0], 'url', this.order.goods_list[0].image_info[0].image);
            //if(this.order.goods_list.length>1)
            //this.$set(this.painting.views[8], 'text', '这单一共'+this.order.goods_list.length+'件商品');
          }
          this.$set(this.painting.views[4], 'url', res.body);
          this.$set(this.painting.views[5], 'text', '#'+this.order.order_no);
          this.$set(this.painting.views[6], 'text', this.order.address.full_name1+' '+this.order.address.mobile);
          let address=`${this.order.address.province}${this.order.address.city}${this.order.address.county}${this.order.address.address1}`
          if(address.length>15)
            address=address.substr(0,15)+'...'
          this.$set(this.painting.views[7], 'text', address);
          console.log('qrcode',res)
        })
    },
    success(src) {
     this.src=src;
    },
    fail(err) {
      console.log('fail', err)
    },
    getTotalFeeWithAllFee(order){
      let cancelGoodsFee=0;
      if(order.goods_list){
        order.goods_list.forEach((g)=>{
          if(g.status == 3)
            cancelGoodsFee+=(+g.discounted_price)*(+g.number);
        })
      }
      return (+order.total_amount)-cancelGoodsFee;
    },
    formatSpec (spec,line) {
      if(line)
        line.isHideSpecLabel=false
      let specStr = ''
      try {
        spec = JSON.parse(spec)
        if(spec.spec){
          //如果是手动填写规格，则直接使用
          return spec.spec;
        }
        else{
          if(line)
            line.isHideSpecLabel=true;
          let orderspec={}
          //对主规格重现排序提到最前
          let specOrder_order=[]
          if(line.unique_param){
            specOrder_order.push(line.unique_param.replace('_list',''))
            specOrder.forEach((i)=>{
              if(i!=line.unique_param.replace('_list',''))
                specOrder_order.push(i)
            })
          }
          else
            specOrder_order=specOrder
          specOrder_order.forEach((i)=>{
            if(spec.hasOwnProperty(i))
              orderspec[i]=spec[i]
          })
          for (let item in orderspec) {
            if (spec[item] && item !== 'merchant') {
              if (specStr !== '') {
                specStr += '<br /> '
              }
              specStr = specStr + SPEC_MAPPER[item] + '：' + spec[item]
            }
          }
        }
      } catch (error) {
        specStr = spec
      }
      return specStr
    },
    async take_by_single () {
      if (!this.isOffLine) {
        if (this.order.offline_payment == '1') {
          this.offline = true
          this.$forceUpdate()
          return
        }
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'take_by_single',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.order.status = '13'
        this.order.update_time = res.result.update_time
        this.order.take_time = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      }
      this.initData()
    },
    async begin () {
      let res = await api.post(this, {
        path: 'order.php',
        api: 'begin',
        data: {
          order_id: this.order.id,
          update_time: this.order.update_time
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.order.status = '14'
        this.order.update_time = res.result.update_time
      }
      this.initData()
    },
    Submit () {
      this.offline = false
      this.isOffLine = true
      this.take_by_single()
    },
    showExpress () {
      let express = document.getElementById('epress' + this.order.id)
      express.click()
    },
    showProductCancel () {
      let productCancelDialog = document.getElementById('product' + this.order.id)
      productCancelDialog.click()
    },
    showChooseImage () {
      this.needChooseImage = true
    },
    showOrderVoucher () {
      let orderVoucher = document.getElementById('voucher' + this.order.id)
      this.needChooseImage = false
      orderVoucher.click()
    },
    showOrderCancel () {
      let orderCancel = document.getElementById('orderCancel' + this.order.id)
      orderCancel.click()
    },
    showChangeAddress () {
      let showChangeAddress = document.getElementById('orderAddress' + this.order.id)
      showChangeAddress.click()
    },
    showUploadOrder () {
      let uploadOrder = document.getElementById('uploadOrder' + this.order.id)
      uploadOrder.click()
    },
    editOrder () {
      this.$store.commit('clearTaskInfo')
      this.$localStorage.set('goBackOrderUrl', this.$route.fullPath)
      this.$router.push({ path: '/buyer/publish_task/confirm', query: {order_id: this.order.id} })
    },
    onCopy (e) {
      this.copyTxtSuccess = true
      console.log('You just copied: ', e.text)
      console.log(this.copyTxtSuccess)
      setTimeout(() => {
        this.copyTxtSuccess = false
      }, 2000)
    },
    onCopyIdCard (e) {
      this.copyIdCardSuccess = true
      console.log(this.copyIdCardSuccess)
      setTimeout(() => {
        this.copyIdCardSuccess = false
      }, 2000)
    },
    onError () {

    },
    // 传递产品图片
    selectProductImage (item) {
      console.log(item)
      let res = {
        item: {
          id: item.id
        },
        response: {
          result: item.url
        }
      }
      this.$refs.UploadExpressDialog.$refs.ProductList.onUploadSuccess(res)
    },
    editOrder () {
      this.$store.commit('clearTaskInfo')
      this.$localStorage.set('goBackOrderUrl', this.$route.fullPath)
      this.$router.push({ path: '/buyer/publish_task/confirm', query: {order_id: this.order.id} })
    },
    hover (index, packageId) {
      this.hoverIndex = index
      this.packageIdIndex = packageId
    },
    copyOrder () {
      this.showCopy = true
    },
    async copyOrderSuccess () {
      let res = await api.getOrderById(this, {
        order_id: this.order.id
      })
      if (res.body.status == 'ok') {
        res = res.body.result
        res.address_info = res.address
        res.coupon = JSON.parse(res.coupon)
        _.each(res.goods_list, goods => {
          goods.business_name = res.business.name
          goods.business_id = res.business.id
          goods.business_website = res.business.website
          goods.currency_symbol = res.currency_symbol
          goods.currency = res.currency
        })
        res.business.business_website = res.business.website
        res.business.business_name = res.business.name
        res.business.business_id = res.business.id
        res.id = ''
        res.fee_adjustment_list = []
        let payment_type_info = {
          card_number: null,
          name: null,
          safety_code: null,
          type: '2',
          valid_date: null
        }
        res.payment_type_id = '47'
        if (this.isSingle) {
          if (this.taskInfo && this.taskInfo.business && this.taskInfo.business.business_name == res.business.name && this.taskInfo.currency == res.currency) {
            _.each(res.goods_list, goods => {
              let flag = false
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website,
                id: +new Date()
              }
              _.each(this.taskInfo.goods_list, list => {
                if (list.name == goods.name) {
                  flag = true
                  return false
                }
              })
              if (!flag) {
                this.taskInfo.goods_list.push(form)
              }
            })
          } else {
            this.taskInfo.business_website = res.business.website
            this.taskInfo.business_name = res.business.name
            this.taskInfo.business_id = res.business.id
            Object.assign(this.taskInfo, res)
          }
        }
        if (!this.isSingle) {
          this.taskInfo.business_website = res.business.website
          this.taskInfo.business_name = res.business.name
          this.taskInfo.business_id = res.business.id
          this.taskInfo.payment_type_info = payment_type_info
          Object.assign(this.taskInfo, res)
        }
        this.$store.commit('updateTaskInfo', this.taskInfo)
        if (!this.isSingle) {
          let flag = false
          let cartList = await api.getCartList(this)
          if (cartList.body.result.length > 0) {
            let list = cartList.body.result
            _.each(res.goods_list, async goods => {
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website
              }
              _.each(list, async item => {
                if (item.status == '0' && item.business_name == form.business_name && item.business_website == form.business_website && item.name == form.name && item.spec == form.spec && item.price == form.price && item.discounted_price == form.discounted_price && item.picture == form.picture && item.website == form.website) {
                  item.currency = form.currency
                  item.currency_symbol = form.currency_symbol
                  item.number = Number(item.number) + Number(form.number)
                  console.log(item.number)
                  flag = true
                  let res = await api.post(this, {
                    path: 'cart.php',
                    api: 'update',
                    data: [item],
                    loading: 'loading'
                  })
                  if (res.body.status == 'ok') {
                    this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
                  }
                }
              })
              if (flag) {
                return
              }
              if (!flag) {
                let res = await api.post(this, {
                  path: 'cart.php',
                  api: 'add',
                  data: [form],
                  loading: 'loading'
                })
                if (res.body.status == 'ok') {
                  console.log(333333)
                  this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
                }
              }
            })
          } else {
            _.each(res.goods_list, async goods => {
              let form = {
                good_id: goods.good_id,
                name: goods.name,
                website: goods.website,
                spec: goods.spec,
                price: goods.price,
                picture: goods.picture,
                discounted_price: goods.discounted_price,
                number: goods.number,
                currency: goods.currency,
                currency_symbol: goods.currency_symbol,
                business_name: goods.business_name,
                business_id: goods.business_id,
                business_website: goods.business_website
              }
              let res = await api.post(this, {
                path: 'cart.php',
                api: 'add',
                data: [form],
                loading: 'loading'
              })
              if (res.body.status == 'ok') {
                console.log(22222)
                this.$router.push({ path: '/publish_task/cart', query: {business_name: this.form.business_name}})
              }
            })
          }
        } else {
          this.$router.push({ path: '/buyer/publish_task/cart' })
        }
        this.showCopy = false
      }
    },
    getPackgeDetail (groupOrderLine, packageId) {
      this.groupOrderLine_temporary = groupOrderLine
      this.packageId_temporary = packageId
      this.showPackge = true
      this.toggleBody(1)
    },
    getGoodDetail () {
      this.showDetail = true
      this.toggleBody(1)
    },
    toggleBody (isPin) {
      if (isPin) {
        $('body').addClass('mobile-body-hidden')
      } else {
        $('body').removeClass('mobile-body-hidden')
      }
    },
    initData () {
      if (this.order.fee_adjustment_list.length > 0) {
        _.each(this.order.fee_adjustment_list, item => {
          this.fee_adjustment_list[0] = item
        })
      }
      this.order.fee_adjustment_list = this.fee_adjustment_list
      if (this.order.status == '30') {
        if (this.order.shipping_info.length > 0) {
          if (this.order.fee_adjustment_list.length == 0) {
            if (Number(this.order.transport_amount) > 0 || Number(this.order.other_amount) > 0) {
              this.showRefundTip = true
            } else {
              this.showRefundTip = false
            }
          } else {
            if (Number(this.order.transport_amount) > 0 || Number(this.order.other_amount) > 0 || Number(this.order.fee_adjustment_list[0].package_forwarding_fee) > 0) {
              this.showRefundTip = true
            } else {
              this.showRefundTip = false
            }
          }
        }
      } else {
        this.showRefundTip = false
      }
      if (this.order.coupon) {
        try {
          this.order.coupon = JSON.parse(this.order.coupon)
          this.order.coupon_text = this.order.coupon.join(' ')
          if (this.order.business && this.order.business.website) {
            this.order.website = this.order.business.website.split(',')[0]
          }
        } catch (e) {

        }
      }
      this.order.conditions = this.order.conditions || {}
      _.each(this.order.goods_list, good => {
        if (good.status == 3 || good.status == 7) {
          good.package_id = good.cancel_time
        }
      })
      this.order.groupOrderLines = _.groupBy(this.order.goods_list, 'package_id')
      console.log('groupOrderLines',this.order.groupOrderLines)
      this.calTotalProductPrice()
      this.timeCal()
    },
    calServiceAmount () {
      let serviceRate, serviceFixedAmount
      if (this.taskInfo.support_transport_service === '1') {
        // 下单
        serviceRate = parseFloat(this.taskInfo.business.single_service_rate === '0' ? this.taskInfo.service_rate.replace('%', '') : this.taskInfo.business.single_service_rate.replace('%', ''))
        serviceFixedAmount = parseFloat(this.taskInfo.business.single_fixed_amount)
      } else if (this.taskInfo.support_transport_service === '2') {
        // 下单 + 转运
        serviceRate = parseFloat(this.taskInfo.business.buyer_service_rate === '0' ? this.taskInfo.service_rate.replace('%', '') : this.taskInfo.business.buyer_service_rate.replace('%', ''))
        serviceFixedAmount = parseFloat(this.taskInfo.business.buyer_fixed_amount)
      }
      this.service_amount = $decimalFormat((serviceRate * this.taskInfo.amount / 100 + serviceFixedAmount),2)
      // this.total_amount = (parseFloat(this.amount) + parseFloat(this.tax_amount) + parseFloat(this.transport_amount) + parseFloat(this.service_amount)).toFixed(2)
    },
    calTotalProductPrice () {
      this.totalProductPrice = 0
      _.each(this.order.goods_list, goods => {
        let price = goods.discounted_price || goods.price
        price = price * goods.number
        if (goods.status != '3') {
          this.totalProductPrice += Number(price)
        }
      })
    },
    timeCal () {
      if (this.order.status != 13 && this.order.status != 14) {
        return
      }
      let response_hours = this.order.conditions.response_hours
      if (response_hours) {
        response_hours = response_hours.replace('小时内响应', '')
      }
      if (isNaN(Number(response_hours))) {
        return
      }
      let latestTime = +new Date(this.order.take_time) + response_hours * 3600 * 1000 - +new Date()
      if (latestTime >= 0) {
        this.order.take_time = msToTime(latestTime)
        this.timer = setInterval(() => {
          latestTime -= 1000
          this.order.take_time = msToTime(latestTime)
        }, 1000)
      }
    },
    complete (data) {
      console.log('data', data)
      this.completion = true
      this.status = data.status
      this.operationType = data.operationType
      this.type = data.type
      this.refund = data.refund
      this.name = data.name
      this.operation = data.operation
      this.confirm = data.confirm
      this.isBuyAgain = data.isBuyAgain
      this.showRefundTip = data.showRefundTip
    },
    updateAddress () {

    },
    closeCompletion () {
      if (this.operationType == '上传发货信息成功' || this.operationType == '取消商品成功') {
        this.showPackge = false
        this.toggleBody(0)
      }
    },
    buyAgain (order, line) {
      console.log('商品信息', line)
      this.isBuy = true
      this.goods = line
    },
    async submit (order, line) {
      let flag = false
      this.form.business_id = order.business.id
      this.form.business_name = order.business.name
      this.form.business_website = order.business.website
      this.form.good_id = line.good_id
      this.form.name = line.name
      this.form.website = line.website
      this.form.spec = line.spec
      this.form.price = line.price
      if (line.picture) {
        this.form.picture = line.picture
      }
      this.form.discounted_price = line.discounted_price
      this.form.currency = order.currency
      this.form.currency_symbol = order.currency_symbol
      let cartList = await api.getCartList(this)
      if (cartList.body.result.length > 0) {
        let list = cartList.body.result
        _.each(list, async item => {
          if (item.status == '0' && item.business_name == this.form.business_name && item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture == this.form.picture && item.website == this.form.website) {
            item.currency = this.form.currency
            item.currency_symbol = this.form.currency_symbol
            item.number = Number(item.number) + 1
            flag = true
            let res = await api.post(this, {
              path: 'cart.php',
              api: 'update',
              data: [item],
              loading: 'loading'
            })
            if (res.body.status == 'ok') {
              this.status = null
              this.confirm = false
              this.operation = false
              this.isBuy = false
              this.completion = true
              this.isBuyAgain = true
              this.operationType = '加入购物车成功'
            }
          }
        })
        console.log(flag)
        if (flag) {
          return
        }
        let res = await api.post(this, {
          path: 'cart.php',
          api: 'add',
          data: [this.form],
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
        }
      } else {
        let res = await api.post(this, {
          path: 'cart.php',
          api: 'add',
          data: [this.form],
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
        }
      }
    },
    taskInfoSubmit (order, line) {
      let flag = false
      this.form.business = order.business
      this.form.business_id = order.business.id
      this.form.business_name = order.business.name
      this.form.business_website = order.business.website
      this.form.good_id = line.good_id
      this.form.name = line.name
      this.form.website = line.website
      this.form.spec = line.spec
      this.form.price = line.price
      if (line.picture) {
        this.form.picture = line.picture
      }
      this.form.discounted_price = line.discounted_price
      this.form.currency = order.currency
      this.form.currency_symbol = order.currency_symbol
      this.form.id = +new Date()
      console.log(this.taskInfo.business_name)
      if (this.taskInfo.business_name) {
        if (this.taskInfo.business_name == this.form.business_name) {
          this.taskInfo.currency = order.currency
          this.taskInfo.currency_symbol = order.currency_symbol
          this.taskInfo.goods_list = this.taskInfo.goods_list || []
          if (this.taskInfo.goods_list) {
            _.each(this.taskInfo.goods_list, item => {
              if (item.business_website == this.form.business_website && item.name == this.form.name && item.spec == this.form.spec && item.price == this.form.price && item.discounted_price == this.form.discounted_price && item.picture == this.form.picture && item.website == this.form.website) {
                item.number = Number(item.number) + 1
                flag = true
                this.status = null
                this.confirm = false
                this.operation = false
                this.isBuy = false
                this.completion = true
                this.isBuyAgain = true
                this.operationType = '加入购物车成功'
                this.$store.commit('updateTaskInfo', this.taskInfo)
              }
            })
          }
          if (flag) {
            return
          }
          this.taskInfo.goods_list.push(this.form)
          this.status = null
          this.confirm = false
          this.operation = false
          this.isBuy = false
          this.completion = true
          this.isBuyAgain = true
          this.operationType = '加入购物车成功'
          this.$store.commit('updateTaskInfo', this.taskInfo)
        } else {
          this.warning = true
        }
      } else {
        this.taskInfo.business = order.business
        this.taskInfo.business.business_id = order.business.id
        this.taskInfo.business_id = order.business.id
        this.taskInfo.business.business_name = order.business.name
        this.taskInfo.business_name = order.business.name
        this.taskInfo.business.business_website = order.business.website
        this.taskInfo.business_website = order.business.website
        this.taskInfo.currency = order.currency
        this.taskInfo.currency_symbol = order.currency_symbol
        this.taskInfo.goods_list = this.taskInfo.goods_list || []
        this.taskInfo.goods_list.push(this.form)
        this.status = null
        this.confirm = false
        this.operation = false
        this.isBuy = false
        this.completion = true
        this.isBuyAgain = true
        this.operationType = '加入购物车成功'
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    coverSubmit (order, line) {
      this.$store.commit('clearTaskInfo')
      this.taskInfo.business = order.business
      this.taskInfo.business_id = order.business.id
      this.taskInfo.business_name = order.business.name
      this.taskInfo.business_website = order.business.website
      this.taskInfo.currency = order.currency
      this.taskInfo.currency_symbol = order.currency_symbol
      this.taskInfo.goods_list = []
      this.taskInfo.goods_list.push(this.form)
      this.status = null
      this.confirm = false
      this.operation = false
      this.isBuy = false
      this.warning = false
      this.completion = true
      this.isBuyAgain = true
      this.operationType = '加入购物车成功'
      this.$store.commit('updateTaskInfo', this.taskInfo)
    },
    selectChat (toAccountId) {
      // this.$store.commit('updateNim', {
      //   showChat: false
      // })
      this.$store.commit('updateNim', {
        pageType: 'detail',
        toAccountId: toAccountId,
        showChat: true
      })
    },
    editAmount () {
      this.isEmptyErrors = true
      this.errors = {}
      if (Number(this.modifyAmount.total_amount) > Number(this.defaultAmount)) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '商品金额不能增加'}
          ]
        }
      }
      if (Number(this.modifyAmount.total_amount) < 0) {
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '商品金额必须大于零'}
          ]
        }
      }
      this.returnAmount = Number(this.modifyAmount.total_amount) - Number(this.defaultAmount)
    },
    initModify () {
      console.log(1)
      if (this.order.type == 2) {
        this.returnAmount = '0.00'
        if (this.order.goods_list && this.order.goods_list.length) {
          _.each(this.order.goods_list, item => {
            if (item.status == 3) {
              this.editTotalFee = true
              this.defaultAmount = this.order.amount
              this.modifyAmount.total_amount = this.order.amount
              // return false
            }
          })
        }
      }
      this.fee_adjustment_list = [{
        original_tax_fee: '',
        tax_fee: '',
        original_transport_fee: '',
        transport_fee: '',
        original_other_fee: '',
        other_fee: '',
        original_package_forwarding_fee: '',
        package_forwarding_fee: '',
        status: ''
      }]
      this.modifyPrice.order_id = this.order.id
      if (this.order.fee_adjustment_list.length == 0) {
        this.modifyPrice.tax_fee = this.order.tax_amount
        this.defaultModify.tax_fee = this.order.tax_amount
        this.modifyPrice.transport_fee = this.order.transport_amount
        this.defaultModify.transport_fee = this.order.transport_amount
        this.modifyPrice.other_fee = this.order.other_amount
        this.defaultModify.other_fee = this.order.other_amount
        this.modifyPrice.package_forwarding_fee = '0.00'
        this.defaultModify.package_forwarding_fee = '0.00'

        if (this.order.type == 2 && (this.order.transport_amount_charge_type == 1 || this.order.transport_amount_charge_type == 3)) {
          this.modifyPrice.package_forwarding_fee = this.order.package_forwarding_fee
          this.defaultModify.package_forwarding_fee = this.order.package_forwarding_fee
        }
        this.fee_adjustment_list[0].original_tax_fee = this.order.tax_amount
        this.fee_adjustment_list[0].original_transport_fee = this.order.transport_amount
        this.fee_adjustment_list[0].original_other_fee = this.order.other_amount
        this.fee_adjustment_list[0].original_package_forwarding_fee = '0.00'
      }
      if (this.order.fee_adjustment_list.length > 0) {
        this.modifyPrice.tax_fee = this.order.fee_adjustment_list[0].tax_fee
        this.defaultModify.tax_fee = this.order.fee_adjustment_list[0].tax_fee
        this.modifyPrice.transport_fee = this.order.fee_adjustment_list[0].transport_fee
        this.defaultModify.transport_fee = this.order.fee_adjustment_list[0].transport_fee
        this.modifyPrice.other_fee = this.order.fee_adjustment_list[0].other_fee
        this.defaultModify.other_fee = this.order.fee_adjustment_list[0].other_fee
        this.modifyPrice.package_forwarding_fee = this.order.fee_adjustment_list[0].package_forwarding_fee
        this.defaultModify.package_forwarding_fee = this.order.fee_adjustment_list[0].package_forwarding_fee
        // if (this.order.type == 2 && (this.order.transport_amount_charge_type == 1 || this.order.transport_amount_charge_type == 3)) {
        //   this.modifyPrice.package_forwarding_fee = this.order.package_forwarding_fee
        //   this.defaultModify.package_forwarding_fee = this.order.package_forwarding_fee
        // }
        this.fee_adjustment_list[0].original_tax_fee = this.order.fee_adjustment_list[0].original_tax_fee
        this.fee_adjustment_list[0].original_transport_fee = this.order.fee_adjustment_list[0].original_transport_fee
        this.fee_adjustment_list[0].original_other_fee = this.order.fee_adjustment_list[0].original_other_fee
        this.fee_adjustment_list[0].original_package_forwarding_fee = this.order.fee_adjustment_list[0].original_package_forwarding_fee
      }
      console.log(1, this.order.total_fee, this.order.total_amount, this.modifyPrice.tax_fee, this.modifyPrice.transport_fee, this.modifyPrice.other_fee)

      this.totalBusinessPrice = $decimalFormat((Number(this.order.total_fee ? this.order.total_fee : 0) + Number(this.modifyPrice.tax_fee) + Number(this.modifyPrice.transport_fee) + Number(this.modifyPrice.other_fee ? this.modifyPrice.other_fee : 0)),2)
      if (this.order.type == 2) {
        this.totalBusinessPrice = $decimalFormat((Number(this.totalBusinessPrice) + Number(this.order.amount || 0)),2)
      }
      console.log(2, this.totalBusinessPrice, this.order.conditions.rate, this.modifyPrice.tax_fee, this.modifyPrice.package_forwarding_fee)

      this.totalPrice = $decimalFormat(((Number(this.totalBusinessPrice)+Number(this.order.service_amount)) * Number(this.order.conditions.rate) + Number(this.modifyPrice.package_forwarding_fee)),2)
      // if()
      if (this.order.fee_adjustment_list.length == 0 && this.order.status != '12') {
        this.needPaid = '0.00'
      }
      if (this.order.fee_adjustment_list.length == 0 && this.order.status == '12') {
        this.needPaid = this.order.rmb_total_amount
      }
      if (this.order.fee_adjustment_list.length > 0) {
        if (['0', '3'].indexOf(this.order.fee_adjustment_list[0].status) > -1) {
          this.needPaid = this.order.fee_adjustment_list[0].unpaid_fee_rmb
        }
        if (['1', '2', '4', '5'].indexOf(this.order.fee_adjustment_list[0].status) > -1) {
          this.needPaid = '0.00'
        }
      }
      console.log('defaultModify', this.defaultModify)
    },
    async getUnpaid () {
      console.log('11111')
      let res = await api.post(this, {
        path: 'order.php',
        api: 'fee_when_adjust_by_single',
        data: this.modifyPrice,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        // if(this.showRefundTip && Number(res.body.result.unpaid_fee_rmb) >0){
        //   this.isEmptyErrors = false
        //   this.errors = {
        //     business_name: [
        //       {message: '当前订单只能退款,不能输入超过现有金额的数值'}
        //     ]
        //   }
        // }else{
        //   this.isEmptyErrors = true
        //   this.errors = {}

        // }
        this.needPaid = (res.body.result.unpaid_fee_rmb).toString()
      }
    },
    modifyBlur (data) {
      if (this.showRefundTip) {
        if (Number(this.modifyPrice.tax_fee) > Number(this.defaultModify.tax_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.transport_fee) > Number(this.defaultModify.transport_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.other_fee) > Number(this.defaultModify.other_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
        if (Number(this.modifyPrice.package_forwarding_fee) > Number(this.defaultModify.package_forwarding_fee)) {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '当前订单只能退款,不能输入超过现有金额的数值'}
            ]
          }
          return
        } else {
          this.isEmptyErrors = true
          this.errors = {}
        }
      }
      this.getUnpaid()

      // console.log(1, this.order.total_fee, this.order.rmb_total_amount, this.modifyPrice.tax_fee, this.modifyPrice.transport_fee, this.modifyPrice.other_fee)
      // console.log(2, this.totalBusinessPrice, this.order.conditions.rate, this.modifyPrice.tax_fee, this.modifyPrice.package_forwarding_fee)
      this.totalBusinessPrice = $decimalFormat((Number(this.order.total_fee || 0) + Number(this.modifyPrice.tax_fee || 0) + Number(this.modifyPrice.transport_fee || 0) + Number(this.modifyPrice.other_fee || 0)),2)
      if (this.order.type == 2) {
        this.totalBusinessPrice = $decimalFormat((Number(this.totalBusinessPrice) + Number(this.order.total_amount || 0)),2)
      }
      this.totalPrice = $decimalFormat(((Number(this.totalBusinessPrice)+Number(this.order.service_amount)) * Number(this.order.conditions.rate) + Number(this.modifyPrice.package_forwarding_fee)),2)
    },
    openModify (title) {
      this.modifyTitle = title
      this.showModify = true
      this.isEmptyErrors = true
      this.errors = {}
      this.initModify()
    },
    nextStep () {
      if (this.modifyPrice.package_forwarding_fee == this.package_forwarding_fee) {
        this.modifyPrice.package_forwarding_fee = 0
      }
      if (this.isEmptyErrors) {
        this.step = 2
      } else {

      }
    },
    async submitModify () {
      if (Number(this.returnAmount) < 0) {
        let res = await api.post(this, {
          path: 'order.php',
          api: 'adjust_amount_by_single',
          data: {order_id: this.order.id, amount: this.modifyAmount.total_amount},
          loading: 'loading'
        })
        if (res.body.status == 'ok') {
          this.returnAmount = '0.00'
        }
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'adjust_fee_by_single',
        data: this.modifyPrice,
        loading: 'loading'
      })
      if (res.body.status == 'ok') {
        // if(this.order.fee_adjustment_list.length > 0){
        //   if(this.modifyPrice.tax_fee != this.order.fee_adjustment_list[0].tax_fee) {
        //     this.fee_adjustment_list[0].original_tax_fee = this.order.fee_adjustment_list[0].tax_fee
        //   }
        //   if(this.modifyPrice.transport_fee != this.order.fee_adjustment_list[0].transport_fee) {
        //     this.fee_adjustment_list[0].original_transport_fee = this.order.fee_adjustment_list[0].transport_fee
        //   }
        //   if(this.modifyPrice.other_fee != this.order.fee_adjustment_list[0].other_fee) {
        //     this.fee_adjustment_list[0].original_other_fee = this.order.fee_adjustment_list[0].other_fee
        //   }
        //   if(this.modifyPrice.package_forwarding_fee != this.order.fee_adjustment_list[0].package_forwarding_fee) {
        //     this.fee_adjustment_list[0].original_package_forwarding_fee = this.order.fee_adjustment_list[0].package_forwarding_fee
        //   }
        // }
        // this.fee_adjustment_list[0].tax_fee = this.modifyPrice.tax_fee
        // this.fee_adjustment_list[0].transport_fee = this.modifyPrice.transport_fee
        // this.fee_adjustment_list[0].other_fee = this.modifyPrice.other_fee
        // this.fee_adjustment_list[0].package_forwarding_fee = this.modifyPrice.package_forwarding_fee
        // this.fee_adjustment_list[0].unpaid_fee_rmb = this.needPaid
        // this.fee_adjustment_list[0].status = '5'
        // if(this.needPaid > 0){
        //   this.fee_adjustment_list[0].status = '0'
        // }
        // if(this.needPaid < 0){
        //   this.fee_adjustment_list[0].status = '3'
        // }
        this.fee_adjustment_list[0] = res.body.result
        console.log(this.fee_adjustment_list)
        // this.order.fee_adjustment_list = this.fee_adjustment_list
        this.$set(this.order, 'fee_adjustment_list', this.fee_adjustment_list)
        this.innerVisible = false
        this.showModify = false
        this.modifySuccess = true
        this.step = 1
        this.$emit('Modify')
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
    $('body').removeClass('mobile-body-hidden')
  },
  watch: {
    order: {
      handler (newName, oldName) {
        if (newName.shipping_info && newName.shipping_info.length) {
          if (newName.support_transport_service == '2' && this.isSingle) {
            let transportList = []
            _.each(newName.shipping_info, item => {
              if (item.transport_express) {
                transportList.push(item.transport_express)
              }
            })
            if (transportList.length > 0) {
              this.transportList = Array.from(new Set(transportList))
              console.log(this.transportList)
            }
          }
        }
      },
      deep: true

    }
  }
}

function msToTime (duration) {
  var seconds = parseInt((duration / 1000) % 60),
    minutes = parseInt((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)))

  hours = (hours < 10) ? '0' + hours : hours
  minutes = (minutes < 10) ? '0' + minutes : minutes
  seconds = (seconds < 10) ? '0' + seconds : seconds

  return hours + ':' + minutes + ':' + seconds
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.constantGroupOrderLine{
  width:130px;
  height:120px;
  display: flex;
  align-items: center;
}
.id_card_div p{
  color: #666666;
  line-height: 22px;
  white-space: normal;
}
.id_card_div .bold {
  color: #333;
  font-size:16px;
  margin-bottom: 3px;
}
.id_card_img{
  width:45%;
  position:relative;
  cursor: pointer;
}
.id_card_img img{
  width:100%;
  object-fit: contain;
}
.id_card_img i{
  display: none;
}
.id_card_img:hover i{
  display: block;
  font-size: 30px;
  position:absolute;
  top:25%;
  left:40%;
}
.suspension{
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  border-top: 1px #ccc solid;
  background-color: #fff;
  z-index: 4444;
  .flexBtn {
    flex-grow: 1;
    text-align: center;
    padding: 15px 0;
    .operationIco{
      font-size: 28px;
      color: #0F66CF;
      &.moneyIco{
        display: inline-block;
        height: 26px;
        width: 25px;
        background-image: url('../../../assets/images/money@2x.png');
        background-repeat: no-repeat;
        background-size: contain;

      }
    }
    .operationBtn{
      font-size: 12px;
      color: #0F66CF;
      margin-top: 15px;
    }
  }
}
.isMobile {
  display: none;
}
.copy{
  width: 14px;
  vertical-align: middle;
}
.copyTxt{
    float: right;
    cursor: pointer;

    &.copyTxtSuccess,&.copyIdCardSuccess{
      background-color: #f4f4f5;
      color: #909399;
      padding-left: 10px;
    }
}
  .order-header {
    background:rgba(243,243,249,1);
    padding: 30px;
    margin-top: 33px;
    border: 1px solid #D7D7D7;
    border-bottom: none;
    overflow: hidden;
    .detail-button {
      float: right;
      color: #0F66CF;
      cursor: pointer;
    }
    .detail-text {
      color: #333333;
      font-size: 14px;
      float: left;
    }
    .detail-time {
      color: #999999;
      font-size: 12px;
      float: left;
      clear: both;
    }
    li {
      float: left;
      margin-right: 50px;
    }

    .business-name {
      min-width: 100px;
      word-break: break-all;
    }

    span {
      color:rgba(136,136,136,1);
      line-height:20px;
    }

    p {
      color:rgba(51,51,51,1);
      line-height:20px;
      padding-top: 5px;

      a {
        cursor: pointer;
        color: #333333;
        .el-icon-caret-bottom {
          padding-left: 3px;
          color: #333333;
        }
      }
    }

    .order-no {
      float: right;
      text-align: right;
      .search_tag{
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
      .moreIcon {
        line-height: 14px !important;
        cursor: pointer;
        text-align: center;
        display: inline-block;
        height: 15px;
        width: 15px;
        border: 1px solid #409eff;
        border-radius: 50%;
        transform: rotate(90deg);
        i {
          color: #409eff !important;
        }
      }
    }
  }
  .order-detail {
    border: 1px solid #D7D7D7;
    border-top: none;
    padding: 25px 50px 30px;

    .line-list {
      border-right: 1px solid #D7D7D7;
      padding-right: 30px;

      .img-container {
        float: left;
        width: 120px;
        height: 120px;

        a {
          position: relative;
          overflow: hidden;
          display: block;
          width: 120px;
          height: 120px;

          .goodsNum{
            position: absolute;
            bottom: 0;
            right:0;
            display: inline-block;
            height: 20px;
            width: 20px;
            border: 1px solid #D7D7D7;
            border-radius: 50%;
            text-align: center;
            font-size: 10px;
            line-height: 16px;
            color: #333333;
            background: #fff;
          }
        }

        img {
          // width: 100%;
          // position: absolute;
          // left: 0;
          // top: 50%;
          // -webkit-transform: translateY(-50%);
          // transform: translateY(-50%);
          height: 120px;
          width: 120px;
          object-fit: contain;
        }
      }

      .order-des {
        float: left;
        margin-top: -5px;
        margin-left: 20px;

        .buyAgain{
          height: 32px;
          width: 80px;
          text-align: center;
          line-height: 32px;
          border: 1px solid #DEE1EB;
          border-radius: 3px;
          background: #F3F3F9;
          font-size: 12px;
          color: #686B73;
          margin-left: 5px;
          cursor:pointer;
          float:right;
        }
      }

      .order-state {
        float: right;
        text-align: right;
        p {
          color: #888888;
          margin-bottom: 20px;
        }
      }
    }

    .order-line {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .name {
        font-size:14px;
        color:rgba(51,51,51,1);
        line-height:20px;
      }

      .order-des {
        position: relative;
        height: 120px;
        .timeIco{
          text-align: center;
          margin-bottom: 10px;
          margin-top: 20px;
        }
        .descripe{
          color: #888;
          font-size: 18px;
          .voucher{
            cursor: pointer;
            text-decoration:underline;
          }
        }
        .order-price{
          font-size: 18px;
          line-height: 32px;
          color: black;
          margin: 0;
        }

        a.order-price {
          color: #FF4650;
          font-size: 18px;
        }

        del.order-price {
          color: #B0B4BF;
          font-size: 16px;
        }
      }

      p {
        font-size:12px;
        color:#333333;
        line-height:17px;
        margin-bottom: 6px;

        span {
          color: #999;
          font-size:12px;
        }
        a {
          color: #333333;
        }
      }

      .price {
        font-size:18px;
        color:rgba(51,51,51,1);
        line-height:25px;
        position: absolute;
        min-width: 200px;
        bottom: 0;
        margin: 0;
      }
    }

    .operation-container {
      padding-left: 50px;
    }
  }

  .popover-price {
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }
  .modify-price {
    padding: 10px 5px;
    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }
  .modify {
    padding: 0 5px;
    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }

  .offlineLabel {
    position: absolute;
    left: -4px;
    font-size: 12px;
    height: 22px;
    width: 60px;
    text-align: center;
    padding: 5px 5px;
    border-radius: 20px;
    color: #fff;
    background: rgb(254,160,0);
  }
  .unpaidlineLabel {
    position: absolute;
    left: -4px;
    font-size: 12px;
    width: 60px;
    height: 22px;
    text-align: center;
    padding: 5px 5px;
    border-radius: 4px;
    color: #fff;
    background: rgb(116,164,232);
  }
  .redirct {
    font-size:24px;
    line-height:33px;
    margin-top: 54px;
    padding-bottom: 70px;
    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }
    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }
  .buyTitle {
    text-align: center;
    color: #333333;
    font-size: 18px;
    padding-bottom: 40px;
  }
  .addCart {
    display: inline-block;
    height: 25px;
    width: 25px;
    background: url('../../../ico/cart_icon.svg') no-repeat;
    background-size:contain;
    vertical-align: middle;
    position: relative;
    margin-right: 10px;
  }
  .website-name {
    font-size:18px;
    color:rgba(51,51,51,1);
    line-height:25px;
    text-align: left;
    word-break: break-all;
  }
  .website-url {
    font-size:13px;
    color:rgba(102,102,102,1);
    line-height:18px;
    text-align: left;
    margin-bottom: 10px;
    word-break: break-all;
  }
  .buyContent {
    border-top: 1px solid #CDCDCD;
    // max-height: 286px;
    // overflow-y: auto;
    // overflow-x: hidden;

    .content-container {
      padding-right: 60px;
      width: 100%;
      position: relative;

      & > div {
        border-bottom: 1px solid #CDCDCD;
        padding: 20px 0;
      }

      .inline-block {
        margin-left: 0;
        margin-top: 10px;
        // position: absolute;
        // bottom: 20px;
      }
    }

    .img-container {
      float: left;
      width: 120px;
      height: 120px;
      overflow: hidden;

      img {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }

    li {
      &:last-child {
        .content-container {
          & > div {
            border-bottom: none;
          }
        }
      }
    }
    .line-des {
      margin-left: 130px;
      position: relative;

      p {
        line-height: 24px;
        word-break: break-all;
        span {
          color: #888888;
        }
        a {
            color: #333333;
          }
      }
      .inline-block {
        margin-left: 0;
        // position: absolute;
        // bottom: -39px;
      }
      .order-price{
        font-size: 18px;
        line-height: 24px;
        color: black;
        margin: 0;
      }

      a.order-price {
        color: #FF4650;
        font-size: 18px;
      }

      del.order-price {
        color: #B0B4BF;
        font-size: 16px;
      }
    }

  }

  .chat-component {
    position: absolute;
    z-index: 999;
    right: 30px;
  }

  .gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);

    filter: grayscale(100%);

    filter: gray;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }
  @media screen and (max-width: 1024px) {
    .notMobile{
      display: none !important;
    }
    .isMobile {
      z-index: 2;
      display: block !important;
    }
    .order-header {

      li {
        margin-right: 23px !important;
      }
    }
    .order-foot {
      overflow: hidden;
      padding: 20px;
      border-left: 1px solid #D7D7D7;
      border-right: 1px solid #D7D7D7;
      border-bottom: 1px solid #D7D7D7;

      .foot-price {
        float: right;

        a {
          color: #333333;
        }
      }
    }
    .order-detail{
      padding: 20px 15px !important;
      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;
        .img-container {
          width: 80px;
          height: 80px;
          a {
            width: 80px;
            height: 80px;
            img {
              width: 80px;
              height: 80px;
            }
          }
        }
        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              cursor: pointer;
              vertical-align: middle;
            }
          }
        }
      }
      .order-line {
        .order-des{
            height: auto;
            margin-left: 10px !important;
        }
      }
    }
  }
  @media screen and (max-width: 769px) {
    .order-header {
      padding: 10px !important;
    }
    .order-detail {
      padding:20px 15px !important;

      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;
        .img-container {
          width: 80px;
          height: 80px;
          a {
            width: 80px;
            height: 80px;
            img {
              width: 80px;
              height: 80px;
            }
          }
          img {
              width: 80px;
              height: 80px;
            }
        }

        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              vertical-align: middle;
            }
          }
        }
      }

      .order-line {

        .order-des {
          height: auto;
          margin-left: 10px !important;

          .name {
            word-break: break-all;
            max-width: 170px;
          }
        }
      }
    }

    .detail-title {
      padding: 10px 0 10px;
      text-align:center;
      font-size:18px;
      color: #333333;
      border-bottom: 1px solid #D7D7D7;
    }

    .detail-body {
      position: relative;
      padding: 15px;
      border-bottom: 1px solid #D7D7D7;
      h2 {
        font-size: 14px;
        color: #333333;
        padding: 10px 0;
      }

      p {
        margin-bottom: 10px;
        color: #888888;
      }

      .popover-price {
        padding: 0 0 10px!important;
      }

      .mobile-order-state {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 25px;
      }

      .buyContent {
        border-top: none !important;
        .img-container {
          width: 80px;
          height: 80px;
        }
        .line-des {
          margin-left: 98px !important;
          .order-price{
            font-size: 14px !important;

            &.a{
              font-size: 14px !important;
            }

            &.del {
              font-size: 14px !important;
            }
          }
          p {
            margin-bottom: 5px !important;
          }

        }
        .content-container {

          &>div {
            border-bottom: none !important;
          }
        }
      }
    }
  }
  .weeCtCoverBeforeDeal {
        position: relative;
        /*width: 380px;*/
        /*width: 310px;*/
        width: 430px;
        height: 135px;
        .coverMore{
            position: absolute;
            right: 0;
            top: 0;
            width: 50px;
            height: 120px;
            background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
            z-index: 1;
        }
        .ctCover{
            height: 120px;
            /*width: 3700px;*/
            display: flex;
            /*flex-wrap: nowrap;*/
            .cover {
                /*display: inline-block;*/
                width: 120px;
                height: 120px;
                margin-right: 10px;
                background-size: contain !important;
                &:last-of-type{
                    margin-right: 25px;
                }
                cursor: pointer;
            }
            /*.gm-scroll-view{*/
            /*    display: flex;*/
            /*}*/
        }
    }
@media screen and (max-width: 1024px) {
  .weeCtCoverBeforeDeal {
    position: relative;
    /*width: 380px;*/
    width: 310px;
    /*width: 430px;*/
    height: 95px;
    .coverMore{
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 80px;
      background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
      z-index: 1;
    }
    .ctCover{
      height: 80px;
      /*width: 3700px;*/
      display: flex;
      /*flex-wrap: nowrap;*/
      .cover {
        /*display: inline-block;*/
        width: 80px;
        height: 80px;
        margin-right: 10px;
        background-size: contain !important;
        &:last-of-type{
          margin-right: 25px;
        }
        cursor: pointer;
      }
      /*.gm-scroll-view{*/
      /*    display: flex;*/
      /*}*/
    }
  }
}
.spec{
  display: flex;
  word-break: break-all;
  color: #888888;
  line-height: 24px;
  span {
    display: block;
  }
}
.joyorderIcon{
    position: relative;
    top: 2px;
}
.joyorderIcon.taobao{
    font-size:20px;
    top:3px;
}
@font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  /* Color fonts */
  src: 
       url('../../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-icon-joyorderxiazai:before {
  content: "\e617";
}

.el-icon-joyordershenfenzhengrenzheng:before {
  content: "\e609";
}

.el-icon-joyorderkefu:before {
  content: "\e606";
}

.el-icon-joyorderweixin:before {
  content: "\e6ea";
}

.el-icon-joyorder26:before {
  content: "\e615";
}

</style>



// WEBPACK FOOTER //
// src/pages/merchantOrders/list/Order.vue